import { Box, Grid, Typography } from '@mui/material';
import MultipleCheckBoxes from '../../../AddLocation/Components/UI/MultipleCheckBoxes';
import CheckboxInput from '../../../AddLocation/Components/UI/CheckboxInput';
import {
  billinglabelTitle,
  detailsValue,
} from '../../../../assets/styles/appStyles';
import * as Styles from '../../../../assets/styles/appStyles';
import { emptyValue } from '../../../../settings/appConfig';
import { gridContainer, infoGridItem } from '../../Styles/CustodianAddressDetailsStyles';

export default function BillingInfoFeesDetails({
  processingFeesSubpoena,
  processingFeesAuthorization,
  initialProcessingFee,
  initialProcessingFeeNotes,
  billingInfoProcessingFeesMethods,
  paymentMethods,
}: {
  paymentMethods: any[];
  billingInfoProcessingFeesMethods: string[];
  processingFeesSubpoena: number;
  processingFeesAuthorization: number;
  initialProcessingFee: boolean;
  initialProcessingFeeNotes: string;
}) {
  return (
    <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
      <Grid container item rowSpacing={3}>
        <Grid item xs={12} sx={infoGridItem}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <MultipleCheckBoxes
                labelStyle={billinglabelTitle}
                options={paymentMethods}
                keyName={''}
                label="Processing fees method"
                selectedValues={billingInfoProcessingFeesMethods}
                toggleChange={() => { }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography sx={billinglabelTitle}>
                Processing Fees (Authorization)
              </Typography>
              <Box sx={Styles.labelText}>
                {!!processingFeesAuthorization
                  ? `${processingFeesAuthorization}$`
                  : emptyValue}
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={billinglabelTitle}>
                <CheckboxInput
                  keyName=""
                  label="Initial processing fees"
                  onBlur={() => { }}
                  onChange={() => { }}
                  checked={initialProcessingFee}
                />
              </Box>
              {initialProcessingFee && (
                <Box>
                  <Typography sx={billinglabelTitle}>Notes</Typography>
                  <Box sx={Styles.labelText}>
                    {initialProcessingFee ? initialProcessingFeeNotes : emptyValue}
                  </Box>
                </Box>
              )}
            </Grid>
            <Grid item xs={6}>
              <Typography sx={billinglabelTitle}>Processing Fees (Subpoena)</Typography>
              <Box sx={Styles.labelText}>
                {!!processingFeesSubpoena ? `${processingFeesSubpoena}$` : emptyValue}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
